import { OpsOrgBrowser } from "@/pages/OpsOrgBrowser";

export default function OpsDemos() {
  return <OpsOrgBrowser demoOnly />;
}
